module.exports = {
  VictoryLabel: require("./components/victory-label")
};



/** WEBPACK FOOTER **
 ** ./src/index.js
 **/